module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.21826/images/logos/hubspot-logo-primary.svg"